import React from "react";
import { Palette, Flame, Music, Utensils } from "lucide-react";
import { AshtadalKamal, CornerVine, DiamondBorder, SectionLabel } from "./AipanPattern";
import { CULTURE_ITEMS, IMAGES } from "../mock";

// const ICONS = [Palette, Flame, Music, Utensils];
const ICONS =  [
  "/images/Kumaun_University_logo.png",
  "/images/Kumauni_4.jpeg",
  "/images/Kumauni_1.jpeg",
  "/images/Kumauni_2.jpeg",
   "/images/Kumauni_3.jpeg",
  
];

export default function Culture() {
  return (
    // <section id="culture" className="relative pt-28 pb-12  bg-[var(--terracotta-deep)] text-white overflow-hidden -mt-[50px]">
      <section
  id="about"
  className="relative pt-24 pb-3 bg-[var(--paper)] paper-grain"
>
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={IMAGES.himalayan1} alt="Himalayas" className="h-full w-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--terracotta-deep)] via-[var(--terracotta-deep)]/95 to-[var(--terracotta-deep)]" />
      </div>

      {/* Aipan corner motifs */}
      {/* <div className="absolute -left-10 top-10 opacity-20">
        <AshtadalKamal size={200} stroke="#f4b063" />
      </div> */}
      <div className="absolute -right-6 bottom-8 opacity-20 rotate-180">
        <CornerVine size={160} stroke="#f4b063" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center -mt-[90px]">
          <div className="inline-flex items-center gap-3 rounded-full border border-white/25 px-4 py-0.5 backdrop-blur-sm bg-white/5 ">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--saffron-light)]" />
            <span className="font-serif text-white/85 text-sm tracking-[0.2em] uppercase ">The Kumaon Way of Life</span>
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--saffron-light)]" />
          </div>
          <h2 className="mt-2 font-display text-[20px] lg:text-[40px] leading-[1.05] font-bold text-white/85">
            A campus shaped by <br /><span className="italic text-[var(--saffron-light)]">culture</span>, community and the hills.
          </h2>
          <DiamondBorder className="my-3 mx-auto max-w-md opacity-80" />
          <p className="mx-auto max-w-2xl font-serif italic text-[17px] leading-relaxed text-white/85">
            Beyond classrooms and laboratories, Kumaun University is inseparable from the traditions
            of the land it grew in — the sacred art of Aipan, the melodies of Baithki Holi, the
            fragrant kitchens of pahari homes and the reverence for Nanda Devi.
          </p>
        </div>

      {/* <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CULTURE_ITEMS.map((c, i) => {
          const image = ICONS[i % ICONS.length];

          return (
            <article
              key={c.title}
              className="rounded-2xl bg-white/5 backdrop-blur-sm border border-white/15 p-6 hover:bg-white/10 transition-colors"
            >
              <div
                className="
                  w-20 h-20
                  sm:w-24 sm:h-24
                  md:w-28 md:h-28
                  lg:w-24 lg:h-24
                  xl:w-28 xl:h-28
                  rounded-2xl
                  bg-[var(--saffron)]/25
                  grid place-items-center
                  mb-5
                  border border-[var(--saffron-light)]/30
                  overflow-hidden
                "
              >
                <img
                  src={image}
                  alt={c.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <h3 className="font-display font-bold text-[19px] sm:text-[20px] leading-tight">
                {c.title}
              </h3>

              <p className="mt-3 text-[13.5px] sm:text-[14px] leading-relaxed text-white/75">
                {c.body}
              </p>
            </article>
          );
        })}
      </div> */}
    

    
<div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">

  {/* Left Side Kulgeet Image Card */}
  {/* <article className="min-w-0 min-h-80 rounded-2xl border border-white/15 overflow-hidden">
    <div
      className="w-full h-full min-h-80 rounded-xl bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('/images/kulgeet.jpeg')",
        backgroundSize: "contain",
      }}
    />
  </article> */}

  {/* Existing 4 Culture Cards */}
  {CULTURE_ITEMS.map((c, i) => {
    const image = ICONS[i % ICONS.length];

    return (
      <article
        key={c.title}
        className="min-w-0 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/15 p-4 hover:bg-white/10 transition-colors"
      >
        <div
          className="
            w-20 h-20
            sm:w-24 sm:h-24
            md:w-28 md:h-28
            lg:w-24 lg:h-24
            xl:w-28 xl:h-28
            rounded-2xl
            bg-[var(--saffron)]/25
            grid place-items-center
            mb-5
            border border-[var(--saffron-light)]/30
            overflow-hidden
          "
        >
          <img
            src={image}
            alt={c.title}
            className="w-full h-full object-cover"
          />
        </div>

        <h3 className="font-display font-bold text-[19px] sm:text-[20px] leading-tight">
          {c.title}
        </h3>

        <p className="mt-3 text-[13.5px] sm:text-[14px] leading-relaxed text-white/75">
          {c.body}
        </p>
      </article>
    );
  })}

</div>

      </div>
    </section>
  );
}
